'use client';

import { usePathname } from 'next/navigation';
import GorgiasChatWidget from './GorgiasChatWidget';

export default function GorgiasWidgetWrapper() {
    const pathname = usePathname();

    return <GorgiasChatWidget path={pathname} />;
}
